import axios from "axios";
import baseAPI from "../api/baseApi";
import {
  authHeader,
  authHeaderWithImage,
  languageHeader,
} from "../helpers/authHeader";
import { toast } from "react-toastify";

const getCategories = async () => {
  try {
    const res = await baseAPI.get(`/get-categories`, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getUserCategories = async (id) => {
  try {
    const res = await baseAPI.get(`/get-categories?user_id=${id}`, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getSystemConfiguration = async () => {
  try {
    const res = await baseAPI.get(`/system-configuration`, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getUserRelatedCategories = async (data) => {
  try {
    const res = await baseAPI.post(`/related-category-list`, data, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getCountries = async () => {
  try {
    const res = await baseAPI.get(`/get-countries`, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getCities = async (data) => {
  try {
    const res = await baseAPI.get(`/get-cities?country_id=${data}`, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getHomePageData = async () => {
  try {
    const res = await baseAPI.get(`/merchant-home`, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getDistrict = async () => {
  try {
    const res = await baseAPI.get(`/get-districts`, {
      headers: languageHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getSubCategories = async (id) => {
  try {
    const res = await baseAPI.get(`/get-sub-categories?category_id=${id}`, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getPrivacyPolicy = async (id) => {
  const lang = localStorage.getItem("language");
  try {
    const res = await baseAPI.get(`/privacy-policy`, {
      headers: {
        language: lang == "ar" ? "ar" : "en",
      },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getTermsCondition = async (id) => {
  const lang = localStorage.getItem("language") === "ar" ? "ar" : "en";
  try {
    const res = await baseAPI.get(`/terms-and-conditions`, {
      headers: {
        language: lang == "ar" ? "ar" : "en",
      },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const addContact = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("name", data.name);
    formdata.append("email", data.email);
    formdata.append("phone_number", data.phone_number);
    formdata.append("message", data.message);

    const res = await baseAPI.post(`/add-contact`, formdata, {
      headers: authHeader(),
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

const additionalDetailSave = async (data) => {
  try {
    const formdata = new FormData();
    formdata.append("merchant_id", data.id);
    formdata.append("req_info_details", data.req_info_details);
    if (Array.isArray(data.req_documents)) {
      data.req_documents.forEach((file) => {
        if (file) {
          formdata.append("req_documents[]", file);
        }
      });
    } else if (data.req_documents) {
      formdata.append("req_documents[]", data.req_documents);
    }

    const res = await baseAPI.post(`/additional-detail-save`, formdata, {
      headers: authHeaderWithImage(),
    });
    return res;
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
  }
};

const CommonService = {
  getCategories,
  getUserCategories,
  getCountries,
  getCities,
  getHomePageData,
  getDistrict,
  getSubCategories,
  getPrivacyPolicy,
  addContact,
  getTermsCondition,
  additionalDetailSave,
  getUserRelatedCategories,
  getSystemConfiguration
};
export default CommonService;
